import React, { useState } from "react";
import TaskComments from "../../views/admin/taskDetails/TaskComments";
import TaskTimeLine from "../../views/admin/taskDetails/TaskTimeLine";
import TaskActivity from "../../views/admin/taskDetails/TaskActivity";
import { useParams } from "react-router-dom";

const Chat_tab_Section = ({ selectedTaskId }) => {
  const [activeTab, setActiveTab] = useState("comments");
  const { id } = useParams();
  const [memberList, setMemberList] = useState([]);
  

  const handleTabChange = (e) => {
    setActiveTab(e.target.name);
  };
  return (
    <div className="m-2 flex-1 lg:h-[350px] md:h-[250px]">
      <div className="flex flex-col justify-start gap-4">
        <ul className="nav nav-pills mb-3 mt-2 border-b-2 border-gray-200 m-2" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link font-medium text-xs ${
                activeTab === "comments" ? "active" : ""
              }`}
              id="pills-comments-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-comments"
              type="button"
              role="tab"
              aria-controls="pills-comments"
              aria-selected="true"
              onClick={(e) => handleTabChange(e)}
              name="comments"
            >
              Comments
            </button>
          </li>
          {/* <li className="nav-item" role="presentation">
            <button
              className={`nav-link font-medium text-xs ${
                activeTab === "time-line" ? "active" : ""
              }`}
              id="pills-time-line-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-time-line"
              type="button"
              role="tab"
              aria-controls="pills-time-line"
              aria-selected="false"
              name="time-line"
              onClick={(e) => handleTabChange(e)}
            >
              Time Line
            </button>
          </li> */}
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link font-medium text-xs ${
                activeTab === "activity" ? "active" : ""
              }`}
              id="pills-activity-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-activity"
              type="button"
              role="tab"
              aria-controls="pills-activity"
              aria-selected="false"
              name="activity"
              onClick={(e) => handleTabChange(e)}
            >
              Activity
            </button>
          </li>
        </ul>
      </div>
      <div className="program_scroll h-[calc(100%_-_70px)]">
        <div className="tab-content h-full" id="pills-tabContent">
          <div
            className={`h-full tab-pane fade ${
              activeTab === "comments" ? "show active" : ""
            }`}
            id="pills-comments"
            role="tabpanel"
            aria-labelledby="pills-comments-tab"
          >
            {activeTab === "comments" && (
              <TaskComments
                task_id={selectedTaskId}
                call_id={2}
                membersList={memberList}
              />
            )}
          </div>
          <div
            className={`tab-pane fade h-full ${
              activeTab === "time-line" ? "show active" : ""
            }`}
            id="pills-time-line"
            role="tabpanel"
            aria-labelledby="pills-time-line-tab"
          >
            {activeTab === "time-line" && (
              <TaskTimeLine call_id={1} task_id={selectedTaskId} />
            )}
          </div>
          <div
            className={`tab-pane fade h-full ${
              activeTab === "activity" ? "show active" : ""
            }`}
            id="pills-activity"
            role="tabpanel"
            aria-labelledby="pills-activity-tab"
          >
            {activeTab === "activity" && (
              <TaskActivity task_id={selectedTaskId} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Chat_tab_Section;
